import React from 'react';
import { Box } from '@mui/material';
import { useState, useEffect } from 'react';
import { keyframes } from '@mui/material/styles';

import NotificationIcon from 'src/icons/NotificationIcon';
import NotificationDisabledIcon from 'src/icons/NotificationDisabledIcon';

// Анимация пульсации для активного состояния
const pulse = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
`;

// Анимация переключения
const switchAnimation = keyframes`
  0% { transform: scale(1) rotate(0deg); opacity: 1; }
  50% { transform: scale(0.8) rotate(-10deg); opacity: 0.3; }
  100% { transform: scale(1) rotate(0deg); opacity: 1; }
`;

interface AnimatedNotificationIconProps {
    isEnabled: boolean;
}

const AnimatedNotificationIcon = React.memo(({ isEnabled }: AnimatedNotificationIconProps) => {
    const [isAnimating, setIsAnimating] = useState(false);
    const [currentIcon, setCurrentIcon] = useState(isEnabled);
    const [animationKey, setAnimationKey] = useState(0);

    useEffect(() => {
        if (currentIcon !== isEnabled) {
            setIsAnimating(true);
            setAnimationKey((prev) => prev + 1);

            // Плавная анимация переключения
            const timer = setTimeout(() => {
                setCurrentIcon(isEnabled);
                setIsAnimating(false);
            }, 300);

            return () => clearTimeout(timer);
        }
    }, [isEnabled, currentIcon]);

    return (
        <Box
            sx={{
                position: 'relative',
                width: 24,
                height: 24,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Box
                key={animationKey}
                sx={{
                    position: 'absolute',
                    transform: isAnimating ? 'scale(0.8) rotate(-10deg)' : 'scale(1) rotate(0deg)',
                    opacity: isAnimating ? 0.3 : 1,
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    animation: isAnimating ? `${switchAnimation} 0.3s ease-in-out` : 'none',
                }}
            >
                {currentIcon ? <NotificationIcon /> : <NotificationDisabledIcon />}
            </Box>
        </Box>
    );
});

AnimatedNotificationIcon.displayName = 'AnimatedNotificationIcon';

export default AnimatedNotificationIcon;
